import { isOlderThanXYear } from '../../../../../helpers/common';

export const handleNegativeClass = (value, date, yearInterval = 2) => {
  return value && !isOlderThanXYear(date, yearInterval);
};
